export function isSimpleObject(value: unknown): value is object {
  return value != null && value.constructor === Object;
}
